import { Item } from "types/Item";
import BaseApiService from "../BaseApiService";

interface CreateHistoryReponse {
	data: {
		id: number;
		attributes: {
			createdAt: string;
			updatedAt: string;
		};
	};
	meta: {};
}

export default class History extends BaseApiService {
	private static instance: History;
	private baseUrl: string;

	private constructor() {
		super();
		this.baseUrl = process.env["REACT_APP_API_URL"]!.concat("/api/histories");
		History.instance = this;
	}

	public static getInstance() {
		if (!History.instance) return new this();
		return History.instance;
	}

	public async create(product: Item, session_id: string, origin: "scan" | "catalog"): Promise<CreateHistoryReponse> {
		const path = this.baseUrl;
		try {
			return await this.postRequest(path, { data: { product, session_id, origin } }, { Authorization: `Bearer ${process.env["REACT_APP_API_KEY"]}` });
		} catch (err) {
			return this.onError(err);
		}
	}
}
